import { useState, useCallback } from 'react';

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import { useTheme, alpha as hexAlpha } from '@mui/material/styles';

import { fShortenNumber } from 'src/utils/format-number';

import { Chart, useChart, ChartSelect, ChartLegends } from 'src/components/circular-chart/chart';

// ----------------------------------------------------------------------

export function ColumnChart({ title, subheader, chart, color, ...other }) {
  const theme = useTheme();

  const [selectedSeries, setSelectedSeries] = useState('Monthly');

  const currentSeries = chart.series.find((i) => i.name === selectedSeries);
  const chartColors = !color
    ? [theme.palette.primary.dark, hexAlpha(theme.palette.error.main, 0.48)]
    : [color, hexAlpha(color, 0.48)];

  const chartOptions = useChart({
    colors: chartColors,
    stroke: { width: 2, colors: ['transparent'] },
    xaxis: { categories: currentSeries?.categories },
    tooltip: { y: { formatter: (value) => `${value}` } },
    ...chart.options,
  });

  return (
    <Card {...other}>
      <CardHeader title={title} subheader={subheader} sx={{ mb: 3 }} />

      <ChartLegends
        colors={chartOptions?.colors}
        labels={chart.series[0].data.map((item) => item.name)}
        sx={{ px: 3, gap: 3 }}
      />

      <Chart
        type="bar"
        series={currentSeries?.data}
        options={chartOptions}
        height={320}
        sx={{ py: 2.5, pl: 1, pr: 2.5 }}
      />
    </Card>
  );
}
